import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface Props {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: Props) {
  return (
    <div className="glass-card flex flex-col items-center gap-3 p-10 text-center">
      <div className="rounded-2xl bg-mustard-500/15 p-3 text-mustard-300">
        <Icon className="h-6 w-6" />
      </div>
      <div className="text-base font-semibold text-moss-200">{title}</div>
      <p className="max-w-sm text-sm text-moss-300/70">{description}</p>
      {action}
    </div>
  );
}
